import { BaseState } from 'src/state/ducks/models';
import {
  EmarketingSentSummaryResponse,
  EmarketingSentDetailResponse,
  EmarketingSentDeleteResponse,
  EmarketingSentBulkResponse,
  EmarketingSentSendResponse,
  EmarketingSentGetByIdResponse,
} from 'src/state/api-models/emarketing-sent';

export type EmarketingSentSummary = BaseState<EmarketingSentSummaryResponse>;
export type EmarketingSentDetails = BaseState<EmarketingSentDetailResponse>;
export type EmarketingSentDelete = BaseState<EmarketingSentDeleteResponse>;
export type EmarketingSentBulk = BaseState<EmarketingSentBulkResponse>;
export type EmarketingSentSend = BaseState<EmarketingSentSendResponse>;
export type EmarketingSentGetById = BaseState<EmarketingSentGetByIdResponse>;

export type EmarketingSentState = {
  summary: EmarketingSentSummary;
  details: EmarketingSentDetails;
  delete: EmarketingSentDelete;
  bulk: EmarketingSentBulk;
  send: EmarketingSentSend;
  getById: EmarketingSentGetById;
};

export const initialState = {
  summary: { loading: false, response: undefined },
  details: { loading: false, response: undefined },
  delete: { loading: false, response: undefined },
  bulk: { loading: false, response: undefined },
  send: { loading: false, response: undefined },
  getById: { loading: false, response: undefined },
};

declare module 'src/state/ducks/models' {
  interface StateAll {
    // match to a duck folder
    'emarketing/sent': EmarketingSentState;
  }
}
